import { useCallback, useEffect, useState } from "react";
import Carousel from "react-multi-carousel";
import { IForm } from "../../models/form";
import { getInProgressForms } from "../../services/formsService";
import { AdminFormCard } from "../../containers/FormCard/AdminFormCard";
import { Loader } from "semantic-ui-react";
import "./AdminForms.css";
import { responsiveCarousel } from "../../helpers/commonHelper";

interface IProps {
    withDelete?: boolean;
    refreshTriggerFlag?: boolean;
}

export const AdminForms = (props: IProps) => {
    const [inProgressForms, setInProgressForms] = useState<IForm[]>([]);
    const [loadingForms, setLoadingForms] = useState(true);

    const fetchInProgressForms = useCallback(async () => {
        setLoadingForms(true);
        const inProgressForms = await getInProgressForms();
        Array.isArray(inProgressForms) && setInProgressForms(inProgressForms);
        setLoadingForms(false);

        // Even though the refreshTriggerFlag is not used in this function, it is a signal that we should refresh the data
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [props.refreshTriggerFlag]);

    useEffect(() => {
        fetchInProgressForms();
    }, [fetchInProgressForms]);

    return (
        <>
            <Loader active={loadingForms} inline="centered" />
            <Carousel responsive={responsiveCarousel}>
                {inProgressForms.map(x => (
                    <div className="action-bar-container" key={x.id}>
                        <AdminFormCard
                            form={x}
                            withDelete={props.withDelete}
                            refresh={fetchInProgressForms}
                        />
                    </div>
                ))}
            </Carousel>
            {inProgressForms.length === 0 && !loadingForms && <b>No forms in progress.</b>}
        </>
    );
};
